/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListCustomerBitcoinPaymentsRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {ListCustomerBitcoinPaymentsResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const listCustomerBitcoinPayments = (request: ListCustomerBitcoinPaymentsRequest, options?: CashRequestOptions) => post<ListCustomerBitcoinPaymentsRequest, ListCustomerBitcoinPaymentsResponse>("/2.0/cash/list-customer-bitcoin-payments", request, {...options, rejectOnError: true })